export default {
  create( _, data ) {
    return {
      taskId:             data.taskId            || null,
      commitmentId:       data.commitmentId      || null,
      goalId:             data.goalId            || null,
      pushId:             data.pushId            || null,
      startedAt:          data.startedAt         || 0,
      durationRemaining:  data.durationRemaining || 0,
      paused:             data.paused            || false,
    }
  },

  fields: {
    taskId: {},
    commitmentId: {},
    goalId: {},
    pushId: {},
    startedAt: {},
    durationRemaining: {},
    duration: {},
    paused: {}
  }
};
